<emperor-button
  [color]="emperorThemeColor.WARN"
  (click)="deletePool()"
  [uiButtonType]="emperorButtonUITypes.Stroked"
>
  <div class="emperor-ui-question-pool-delete-button">
    {{ text | uppercase }} <emperor-icon name="remove_circle_2"></emperor-icon>
  </div>
</emperor-button>
